import { render, staticRenderFns } from "./addMenuUser.vue?vue&type=template&id=2c767f17&scoped=true"
import script from "./addMenuUser.vue?vue&type=script&lang=js"
export * from "./addMenuUser.vue?vue&type=script&lang=js"
import style0 from "./addMenuUser.vue?vue&type=style&index=0&id=2c767f17&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c767f17",
  null
  
)

export default component.exports